import { Controller } from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {

    connect() {
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.element.addEventListener('click', async (e) => {
            e.preventDefault();

            const remove = this.element.getAttribute('data-remove');
            const id = this.element.getAttribute('data-product-id');
            this.element.classList.toggle('wishlisted');

            if (remove) {
                const table = document.querySelector('.wishlist-table');
                this.element.closest('.cart_item').remove();
                if (table) {
                    if (table.querySelectorAll('tbody tr').length === 0) {
                        table.style.display = 'none';
                        const info = table.parentElement.querySelector('.woocommerce-info');
                        if (info) {
                            info.style.display = 'block';
                        }
                    }
                }
            }

            let response = null;
            try {
                response = await Axios.post(`${theme.rest_route}wishlist/?rest_language=${this.currentLanguageCode}`, {
                    'product_id': id,
                }, {
                    headers: {'X-WP-Nonce': theme.nonce},
                });
                if (response.data) {
                    response = response.data;
                    if ( !response.success ) {
                        this.element.classList.toggle('wishlisted');
                    }
                }
            } catch (error) {
                if (error.response) {
                    this.element.classList.toggle('wishlisted');
                }
            }
        });
    }
}